// import { FieldClassification } from "../enums/FieldClassifications";

export default function fieldFollowsThirdPartyRules(fieldClassification, isThirdParty, thirdPartyShortNames) {
    // This logic may need to be updated, since IsThirdParty is supposed to only apply to folders now
    const isThirdPartyClassification =
        Array.isArray(thirdPartyShortNames) && thirdPartyShortNames.includes(fieldClassification);

    return isThirdPartyClassification || isThirdParty;
}

export function containsThirdPartyFields(fields, thirdPartyShortNames) {
    if (!fields || !thirdPartyShortNames || thirdPartyShortNames.length === 0) return false;
    // Get all IDs where ShortName is "3PM" or "3PC"

    // Check if any field's FieldClassification matches one of those IDs
    return fields.some(x => thirdPartyShortNames.includes(x.FieldClassification));
}

export function contains3PMFields(fields) {
    if (!fields) return false;
    // Check if any field's FieldClassification matches one of those IDs
    return fields.some(x => x.FieldClassification === "3PM");
}
